<template>
    <Transition v-if="isLoading"
                name="spinner">
        <div id="cover-spin"></div>
    </Transition>

    <v-form :name="props.formProps.formName">
        <Tabs value="0"
              scrollable>

            <TabList class="mb-4">
                <Tab value="0">{{ __('Basic data') }}</Tab>
                <Tab value="1">{{ __('Changelog') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0"
                          :header="__('Basic data')">
                    <div class="grid">
                        <FormInputText fieldName="product_name"
                                       label="Product name"
                                       validation="required"
                                       size="8"
                                       :isFormDisabled="isFormDisabled"
                                       :isFocus="true"
                                       v-model:field="crud.product_name" />

                        <FormSelect fieldName="assortment_id"
                                    label="Assortment"
                                    size="4"
                                    validation="required"
                                    :isFormDisabled="isFormDisabled"
                                    :options="select?.assortments"
                                    v-model:field="crud.assortment_id" />
                    </div>
                    <div class="grid">
                        <FormInputText fieldName="part_number"
                                       label="Part number"
                                       size="4"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.part_number" />

                        <FormInputText fieldName="features"
                                       label="Features"
                                       size="4"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.features" />

                        <FormInputText fieldName="unit"
                                       label="Unit"
                                       size="2"
                                       validation="required"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.unit" />

                        <FormInputNumber fieldName="price"
                                         label="Price"
                                         size="2"
                                         :isFormDisabled="isFormDisabled"
                                         v-model:field="crud.price" />
                    </div>
                    <div class="grid">
                        <FormFileUploader fieldName="files"
                                          label="Documents"
                                          category="documents"
                                          :allowedExtensions="['pdf', 'docx', 'xlsx', 'txt']"
                                          :style="{ minWidth: '200px' }"
                                          :isFormDisabled="isFormDisabled"
                                          v-model:field="crud.files" />
                        <FormFileUploader fieldName="files"
                                          label="Pictures"
                                          category="pictures"
                                          imgPosition="right"
                                          :allowedExtensions="['jpg', 'jpeg', 'png', 'gif']"
                                          :style="{ minWidth: '200px' }"
                                          :isFormDisabled="isFormDisabled"
                                          v-model:field="crud.files" />
                    </div>

                    <div class="grid">
                        <FormEditor fieldName="description"
                                    label="Description"
                                    :isFormDisabled="isFormDisabled"
                                    v-model:field="crud.description" />
                    </div>
                </TabPanel>

                <TabPanel v-if="crud.log"
                          value="1"
                          :pt="{ root: { class: 'form-tab-panel' } }">
                    <ChangeLog :log="crud?.log" />
                </TabPanel>
            </TabPanels>
        </Tabs>

        <div class="grid">
            <FormButtons :formProps="props.formProps"
                         :sourceForm="crud"
                         :validation="validation"
                         v-model:isFormDisabled="isFormDisabled">
            </FormButtons>
        </div>
    </v-form>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import { validation, initForm } from '@pages/Helper/crud_utils.js'
import FormInputText from '@crud/FormInputText.vue'
import FormSelect from '@crud/FormSelect.vue'
import FormInputNumber from '@crud/FormInputNumber.vue'
import FormFileUploader from '@crud/FormFileUploader.vue'
import FormEditor from '@crud/FormEditor.vue'
import FormButtons from '@crud/FormButtons.vue'
import ChangeLog from '@crud/ChangeLog.vue'
import { __ } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    formProps: Object,
})

const isLoading = ref(true);
const isFormDisabled = ref(true)
const crud = ref({})

const options = ['assortments'];
const select = ref(null);

// -----------------------------------------------------

onMounted(async () => {
    await initForm(props, crud, isLoading, options, select)
})

// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
